import '@material/web/icon/icon.js'
import '@material/web/chips/assist-chip.js'

import { css, html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'
import { RouteController } from '@operato/shell'
import { ButtonContainerStyles, ScrollbarStyles } from '@operato/styles'
import { sleep } from '@operato/utils'

import { ContextToolbarOverlayStyle } from '../styles/ox-context-toolbar-overlay-style.js'

@customElement('ox-page-action-overlay-template')
export class PageActionOverlayTemplate extends LitElement {
  static get styles() {
    return [
      ScrollbarStyles,
      ButtonContainerStyles,
      ContextToolbarOverlayStyle,
      css`
        :host {
          display: flex;
          flex-wrap: wrap;
          gap: var(--spacing-small);
          align-items: center;
        }

        :host *:focus {
          outline: none;
        }

        md-icon[working] {
          animation: rotate 1s linear infinite;
        }

        md-assist-chip[icon-only] {
          --md-assist-chip-trailing-space: 0;
        }

        @keyframes rotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `
    ]
  }

  private _route = new RouteController(this)

  render() {
    const actions = this._route.context?.actions?.filter((action: any) => !!action) || []

    return html`
      ${actions.map(($action: any, idx: number) => {
        let { type, title, icon, action, select, href, emphasis } = $action as any
        let { raised, danger } = emphasis || {}

        return type == 'text'
          ? html` <span>${title}</span> `
          : type == 'select' || (select && select.length > 0)
            ? html`
                <select @change=${action}>
                  ${select.map((option: any) => html` <option>${option}</option> `)}
                </select>
              `
            : type == 'link'
              ? html` <a href=${href}>${title}</a> `
              : html`
                  <md-assist-chip
                    ?icon-only=${type == 'icon' || !title}
                    ?elevated=${raised}
                    ?danger=${danger}
                    label=${title}
                    @click=${async (e: MouseEvent) => {
                      /* all actions should be bloked for a second */
                      const button = e.currentTarget as any
                      const iconElement = button.querySelector('[slot="icon"]')
                      if (iconElement) {
                        iconElement.textContent = 'refresh'
                        iconElement.setAttribute('working', true)
                      }
                      button.disabled = true

                      try {
                        await action()
                      } finally {
                        await sleep(1000) /* waiting for additionla 1 second */

                        /* because icon can be changed after sleep, don't use closure 'icon'. */
                        if (iconElement) {
                          iconElement.textContent = actions[idx]?.icon
                          iconElement.removeAttribute('working')
                        }
                        button.disabled = false
                      }
                    }}
                  >
                    <md-icon slot="icon">${icon || 'done_all'}</md-icon>
                  </md-assist-chip>
                `
      })}
    `
  }
}
